import api from '.';

export const _saveUser = async (json, headers) => {
    return await api.post('usuarios', json, headers).then(response => { return response });
}

export const _validateMail = async (json, headers) => {
    return await api.post('usuarios/verificaemail', json, headers).then(response => { return response });
}